<template>
  <div>
    <div class="filter">
      <div class="row">

        <div class="column medium-3">
          <div class="search-box">
            <label class="field-label">{{ $t('transactions.filter.search') }}:</label>
            <div class="search">
              <div class="search-input-box">
                <input type="text" v-model="searchInput" :disabled="loading"
                  v-on:keypress.enter="search" :class="{'has-error':!!hasError.searchMsg}"
                  v-on:blur="blurSearch" ref="search"/>
                  <transition name="fade">
                    <i class="far fa-times-circle fa-lg" @click="clearSearch"
                      v-show="searchInput.length > 0"></i>
                  </transition>
              </div>
              <button :class="{'button xsmall success':true, 'disabled':loading}"
                @click="search">
                <i class="fas fa-search fa-lg"></i>
              </button>
            </div>

            <transition name="slide-up">
              <div class="error-msg" v-show="!!hasError.searchMsg">
                {{ hasError.searchMsg }}
              </div>
            </transition>
          </div>
        </div>

        <!-- <div class="column medium-2">
          <label class="field-label">{{ $t('transactions.filter.status') }}:</label>
          <select v-model="status" :disabled="loading">
            <option value="">{{ $t('transactions.filter.all') }}</option>
            <option value="Declined">{{ $t('transactions.filter.declined') }}</option>
            <option value="Cancelled">{{ $t('transactions.filter.cancelled') }}</option>
            <option value="Purchased">{{ $t('transactions.filter.purchased') }}</option>
            <option value="Promo">{{ $t('transactions.filter.promo') }}</option>
            <option value="Authorized">{{ $t('transactions.filter.authorized') }}</option>
            <option value="No Show">{{ $t('transactions.filter.noShow') }}</option>
            <option value="Completed">{{ $t('transactions.filter.completed') }}</option>
            <option value="Refund">{{ $t('transactions.filter.refund') }}</option>
            <option value="Edited">{{ $t('transactions.filter.edited') }}</option>
          </select>
        </div> -->

        <div class="column medium-9">
          <div class="date-range">
            <label class="field-label">{{ $t('transactions.filter.dateRange') }}:</label>
            <select v-model="dateType" :disabled="loading">
              <option value="all">{{ $t('transactions.filter.all') }}</option>
              <option value="custom">{{ $t('transactions.filter.custom') }}</option>
              <option value="withinDay">{{ $t('transactions.filter.withinDay') }}</option>
              <option value="monthToDate">{{ $t('transactions.filter.monthToDate') }}</option>
              <option value="lastMonth">{{ $t('transactions.filter.lastMonth') }}</option>
              <option value="lastWeek">{{ $t('transactions.filter.lastWeek') }}</option>
              <option value="last2Week">{{ $t('transactions.filter.last2Week') }}</option>
              <option value="last30Days">{{ $t('transactions.filter.last30Days') }}</option>
              <option value="last60Days">{{ $t('transactions.filter.last60Days') }}</option>
              <option value="last90Days">{{ $t('transactions.filter.last90Days') }}</option>
            </select>

            <div class="datepicker-div">
              <div class="datepicker-box">
                <datepicker :format="calendarFormat"
                  :class="{'datepicker inline':true, 'has-error':false}"
                  v-model="date.from" ref="datepickerFrom"
                  v-on:input="updateFromTo('from')" :disabled-picker="loading"
                  :input-class="{'datepicker-empty':hasError.from}"
                  :placeholder="$t('transactions.filter.from')"></datepicker>
              </div>

              <div class="datepicker-box">
                <datepicker :format="calendarFormat" class="datepicker inline"
                  v-model="date.to" ref="datepickerTo"
                  v-on:input="updateFromTo('to')" :disabled-picker="loading"
                  :input-class="{'datepicker-empty':hasError.to}"
                  :placeholder="$t('transactions.filter.to')"></datepicker>
              </div>
            </div>

            <transition name="slide-up">
              <div class="error-msg" v-show="!!hasError.fromToMsg">
                {{ hasError.fromToMsg }}
              </div>
            </transition>
          </div>
        </div>

        <!-- <div class="column medium-2">
          <div class="export">
            <a :class="{'button cta success small':true, 'disabled':!transactions.length || loading}"
              @click="exportTrx">{{ $t('transactions.filter.export') }}</a>
          </div>
        </div> -->
        <!-- <div class="data-field col col25">
          <div class="search">
            <input type="text" />
            <button class="button xsmall success">{{ $t('consumer.transactions.search') }}</button>
          </div>
        </div>

        <div class="data-field col col20">
          <div class="label">{{ $t('consumer.transactions.from') }}:</div>
          <datepicker class="datepicker" v-model="from" :format="calendarFormat"
            v-on:input="updateFromTo('from')"></datepicker>
        </div>

        <div class="data-field col col20">
          <div class="label">{{ $t('consumer.transactions.to') }}:</div>
          <datepicker class="datepicker" v-model="to" :format="calendarFormat"
            v-on:input="updateFromTo('from')"></datepicker>
        </div> -->

      </div>
    </div>

    <div class="clearfix"></div>

    <table  v-if="!isMobile">
      <thead>
        <th :class="{'sortable':true, 'sort':sort.active ==='created'}"
          @click="sortTable('created')">
          Date Created
          <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
        </th>
        <!-- <th>{{ $t('consumer.transactions.providerId') }}</th>
        <th>{{ $t('consumer.transactions.company') }}</th> -->
        <th>Hudson ID</th>
        <th :class="{'sortable':true, 'sort':sort.active ==='rsvpId'}"
          @click="sortTable('rsvpId')">
          ID
          <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
        </th>
        <th>Status</th>
        <th>Pickup Time</th>
        <th>Pickup</th>
        <th>Dropoff</th>
        <th>Service</th>
        <th>PAX/Luggage</th>
        <th>Flight</th>
        <th>Fare</th>
        <!-- <th :class="{'sortable':true, 'sort':sort.active ==='eventId'}"
          @click="sortTable('eventId')">
          {{ $t('consumer.transactions.invoiceId') }}
          <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
        </th>
        <th :class="{'sortable':true, 'sort':sort.active ==='isAsap'}"
          @click="sortTable('isAsap')">
          {{ $t('consumer.transactions.type') }}
          <i :class="['fas', sort.isDesc ? 'fa-sort-down' : 'fa-sort-up']"></i>
        </th> -->
        <!-- <th>{{ $t('consumer.transactions.guestFirstName') }}</th>
        <th>{{ $t('consumer.transactions.guestLastName') }}</th>
        <th>{{ $t('consumer.transactions.mobile') }}</th> -->
        <!-- <th>{{ $t('consumer.transactions.creditCard') }}</th>
        <th>{{ $t('consumer.transactions.bookedThrough') }}</th>
        <th>{{ $t('consumer.transactions.finalOffer') }}</th>
        <th>{{ $t('consumer.transactions.chargedAmount') }}</th>
        <th>{{ $t('consumer.transactions.promoUsed') }}</th> -->
        <!-- <th>{{ $t('consumer.transactions.status') }}</th> -->
        <!-- <th><i class="stripe-icon fab fa-stripe-s"></i></th> -->
      </thead>
      <tbody>
        <tr v-for="trx in transactions" v-show="transactions.length > 0">
          <!-- <td>{{ trx.date }}</td> -->
          <!-- <td>
            <a v-bind:href="'/#/provider/' + trx.providerId" target="_blank">{{ trx.providerId }}</a>
          </td>
          <td>{{ trx.company }}</td> -->
          <td>{{ trx.date }}</td>
          <td>{{ trx.externalId }}</td>
          <td>
            <a v-bind:href="'/#/reservation/' + trx.rsvpId" target="_blank" v-if="trx.rsvpId !== 0">{{ trx.rsvpId }}</a>
            <a v-bind:href="'/#/package/' + trx.pkgId" target="_blank" v-else>
              {{ trx.pkgId }} <i class="fa fa-cube"></i>
            </a>
          </td>
          <td><span :class="'status ' + trx.status + ''">{{ getLabel(trx.status) }}</span></td>
          <td>{{ trx.pickupTime }}</td>
          <td>{{ trx.pickupLocation }}</td>
          <td>
            <span v-if="trx.isCharter">--</span>
            <span v-else>{{ trx.dropoffLocation }}</span>
          </td>
          <td class="service" width="150">
            <span v-bind:class="['service-label', trx.service.name]" v-if="useOldQuatation">{{ serviceLabel(trx.service.id) }}</span>
            <span class="service-label" :style="{backgroundColor: trx.service.color}" v-else>{{ trx.service.label }}</span>
          </td>
          <td>{{ trx.pax }}/{{ trx.luggage }}</td>
          <td>{{ trx.flight }}</td>
          <td>{{ trx.fare }}</td>
          <!-- <td>
            <span v-if="trx.trxId !== '0'">{{ trx.trxId }}</span>
            <span v-else>--</span>
          </td>
          <td>
            <span v-if="trx.pkgId" class="package">PKG</span>
            <span :class="['rsvp-type', trx.type]" v-else>{{ trx.type }}</span>
          </td> -->
          <!-- <td>{{ trx.firstName }}</td>
          <td>{{ trx.lastName }}</td>
          <td><a @click="call(trx)">{{ trx.mobile }}</a></td> -->
          <!-- <td>{{ trx.creditCard }}</td>
          <td class="bookedThrough">
            <span v-bind:class="['booked-label', trx.bookedThrough]">{{ trx.bookedThrough }}</span>
          </td>
          <td>{{ trx.finalOffer }}</td>
          <td>{{ trx.chargedAmount }}</td>
          <td>{{ trx.promoUsed }}</td> -->
          <!-- <td class="status">
            <span v-bind:class="['status-label', trx.statusLabel]">{{ trx.statusLabel }}</span>
          </td> -->
          <!-- <td>
            <span v-if="trx.paymentURL === null">--</span>
            <a v-else :href="trx.paymentURL" target="_blank"><i class="fa fa-link"></i></a>
          </td> -->
        </tr>

        <tr v-show="loading">
          <td colspan="14" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              Getting reservations...
          </td>
        </tr>

        <tr>
          <td colspan="14" class="table-block" v-show="transactions.length === 0 && !loading">
            No reservations as of yet
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <div v-if="transactions.length > 0">
        <div class="cards" v-for="(trx, i) in transactions" :key="i">
          <div class="card">
            <div class="card-header">
              <div class="time">
                {{trx.date}}
              </div>
              <div class="amount">
                <strong>{{ trx.fare }}</strong>
              </div>
            </div>
            <div class="tags">
                 <div class="service">
                    <span v-bind:class="['service-label', trx.service.name]" v-if="useOldQuatation">{{ serviceLabel(trx.service.id) }}</span>
                    <span class="service-label" :style="{backgroundColor: trx.service.color}" v-else>{{ trx.service.label }}</span>
                 </div>
                 <div class="type">
                    <span :class="'status ' + trx.status + ''">{{ getLabel(trx.status) }}</span>
                 </div>
            </div>
            <div class="title">
              <span class="label">ID:</span>
              <div class="rsvpId">
                <a v-bind:href="'/#/reservation/' + trx.rsvpId" target="_blank" v-if="trx.rsvpId !== 0">{{ trx.rsvpId }}</a>
                <a v-bind:href="'/#/package/' + trx.pkgId" target="_blank" v-else>
                  {{ trx.pkgId }} <i class="fa fa-cube"></i>
                </a>
              </div>
              <span class="label">Hudson ID:</span>
              <div>
                <span v-if="trx.externalId">{{ trx.externalId }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="title">
              <span class="label">Pickup Time:</span>
              <div class="value">
                {{ trx.pickupTime }}
              </div>
            </div>
            <div class="title">
              <span class="label">Pickup:</span>
              <div class="value">{{ trx.pickupLocation }}</div>
            </div>
            <div class="title">
              <span class="label">Dropoff:</span>
              <div class="value">{{ trx.dropoffLocation }}</div>
            </div>
            <div class="title">
              <span class="label">Pax/Luggage:</span>
              <div class="value">{{ trx.pax }}/{{ trx.luggage }}</div>
            </div>
            <div class="title">
              <span class="label">Flight:</span>
              <div class="value">{{ trx.flight }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        No reservations as of yet {{transactions.length}}
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import ApiTransactions from '@/modules/api/consumer/reservations'
import CsvExport from 'csvexport'
import services from '../../modules/api/services'

const exporter = CsvExport.create({
  filename: "export.csv",
  columns: [
    'Date', 'Booking Time', 'Pickup Time', 'Service Area', 'Prov ID',
    'Prov License', 'Company', 'RSVP ID', 'Invoice ID', 'Service Type',
    'First Name', 'Last Name', 'Credit Card', 'Email', 'Mobile', 'Source',
    'Final Offer', 'Charge Amount', 'Refunded Amount', 'Promo Used', 'Driver Payment',
    'Bonus', 'Cancel Fees', 'Status', 'Pickup Location', 'Dropoff Location'
  ]
});

export default {
  name: 'reservations',
  props: ['conId', 'isMobile'],
  components: { datepicker },
  data () {
    return {
      searchInput: '',
      blurDelay: '',
      from: '',
      to: '',
      hasError: {
        searchMsg: '',
        from: false,
        to: false,
        fromToMsg: ''
      },
      loading: false,
      sort: {
        active: 'created',
        isDesc: true
      }
    }
  },
  computed: {
    status:{
      get: function () { return this.$store.state.consumer.reservations.status },
      set: function (value) {
        this.$store.commit('consumer/setRsvpStatus', value)
        if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
          this.hasError.from = this.date.from === ''
          this.hasError.to = this.date.to === ''
          return
        }
        this.getTransactions(true)
      }
    },
    dateType: {
      get: function () { return this.$store.state.consumer.reservations.date },
      set: function (value) {
        this.$store.commit('consumer/setRsvpDate', value)

        let from = ''
        let to = value === 'all' ? '' : moment().format('MM/DD/YYYY')
        if (value === 'withinDay') {
          from = moment().format('MM/DD/YYYY')
        }
        if (value === 'monthToDate') {
          from = moment(moment().format('MM') + '/1/' + moment().format('YYYY'), 'MM/DD/YYYY').format('MM/DD/YYYY')
        }
        if (value === 'lastMonth') {
          let lastMonth = moment().subtract(1, 'months')
          from = lastMonth.format('MM/01/YYYY')
          to = lastMonth.endOf('month').format('MM/DD/YYYY')
        }
        if (value === 'lastWeek') {
          let subtractDays = 0
          let currentDate = parseInt(moment().format('E'))
          if (currentDate !== 7) { subtractDays = currentDate }

          from = moment().subtract(subtractDays + 6, 'days').format('MM/DD/YYYY')
          to = moment().subtract(subtractDays, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last2Week') {
          let subtractDays = 0
          let currentDate = parseInt(moment().format('E'))
          if (currentDate !== 7) { subtractDays = currentDate }
          from = moment().subtract(subtractDays + 13, 'days').format('MM/DD/YYYY')
          to = moment().subtract(subtractDays, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last30Days') {
          from = moment().subtract(30, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last60Days') {
          from = moment().subtract(60, 'days').format('MM/DD/YYYY')
        }
        if (value === 'last90Days') {
          from = moment().subtract(90, 'days').format('MM/DD/YYYY')
        }

        if (value !== 'custom') {
          this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' }
          this.$store.commit('consumer/setRsvpDateFrom', from)
          this.$store.commit('consumer/setRsvpDateTo', to)

          if (value === 'all' && this.searchInput === '') {
            this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty')
            let self = this
            self.$nextTick(() => { self.$refs.search.focus() })
            return
          }

          this.getTransactions(true)
        }
      }
    },
    date () {
      let filter = this.$store.state.consumer.reservations
      return {
        from: filter.dateFrom,
        to: filter.dateTo
      }
    },
    transactions () { return this.$store.state.consumer.reservations.list },
    isMax () { return this.$store.state.consumer.reservations.isMax },
    useOldQuatation () { return CONFIG.useOldQuatation }
  },
  methods: {
    init () {
      let self = this
      self.$store.commit('consumer/resetRsvpFilters')
      self.$store.commit('consumer/setRsvpDateFrom', moment().subtract(30, 'days').format('MM/DD/YYYY'))
      self.$store.commit('consumer/setRsvpDateTo', moment().format('MM/DD/YYYY'))

      self.getTransactions(true)
    },
    search () {
      this.searchInput = this.searchInput.trim()
      this.$store.commit('consumer/setRsvpSearch', this.searchInput)

      if (this.searchInput === '' && this.dateType === 'all') {
        this.hasError.searchMsg = this.$t('transactions.filter.searchEmpty')
        return
      }
      this.hasError.searchMsg = ''

      if ((this.date.from === '' || this.date.to === '') && this.dateType !== 'all') {
        this.hasError.from = this.date.from === ''
        this.hasError.to = this.date.to === ''
        return
      }

      if (this.searchInput !== '') {
        this.$store.commit('consumer/setRsvpDate', 'all')
        this.$store.commit('consumer/setRsvpDateFrom', '')
        this.$store.commit('consumer/setRsvpDateTo', '')
      }
      this.getTransactions(true)
    },
    blurSearch () {
      let self = this
      if (self.$store.state.consumer.reservations.search === self.searchInput.trim()) {
        return
      }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    clearSearch () {
      if (this.blurDelay) { clearTimeout(this.blurDelay) }

      if (this.loading) { return }

      this.searchInput = ''
      this.$store.commit('consumer/setRsvpSearch', this.searchInput)
      this.dateType = 'last30Days'
    },
    calendarFormat (date) {
      return moment(date).format('MM/DD/YYYY');
    },
    updateFromTo (fromTo) {
      this.$store.commit('consumer/setRsvpDate', 'custom')

      let format = 'MM/DD/YYYY'
      let from = ''
      let to = ''

      if (fromTo === 'from') {
        this.hasError.from = false
        from = moment(this.date.from)
        this.$store.commit('consumer/setRsvpDateFrom', from.format(format))
        if (this.date.to) { to = moment(this.date.to, format) }
      } else {
        this.hasError.to = false
        to = moment(this.date.to)
        this.$store.commit('consumer/setRsvpDateTo', to.format(format))
        if (this.date.from) { from = moment(this.date.from, format) }
      }

      this.hasError = { searchMsg: '', from: false, to: false, fromToMsg: '' }

      if (this.date.from === '' || this.date.to === '') {
        if (fromTo === 'from') { this.hasError.to = true }
        else { this.hasError.from = true }
        this.hasError.fromToMsg = this.$t('transactions.filter.emptyDate')
        return
      }
      if (from.format('x') > to.format('x')) {
        this.hasError.from = true
        this.hasError.to = true
        this.hasError.fromToMsg = this.$t('transactions.filter.invalidDateRange')
        return
      }
      this.getTransactions(true)
    },
    getLabel(item) {
      switch(item) {
        case "ready": return "Ready to go"
        case "onboard": return "On Board"
        case "requires_dispatch": return "Requires Dispatch"
        case "complete": return "Completed"
        default: return item
      }
    },
    getTransactions (clearList) {
      let self = this
      if ((self.isMax && !clearList) || self.loading) { return }

      if (clearList) {
        this.$store.commit('consumer/resetReservations')
        this.$store.commit('consumer/setReservationsIsMax', false)
        this.$store.commit('consumer/setReservationsCurrentPage', 0)
      }

      self.loading = true
      ApiTransactions.getTransactions(self, self.conId, function () {
        self.loading = false
      })
    },
    exportTrx () {
      let self = this
      ApiTransactions.exportTransactions(self, self.conId, function (res) {
        if (!res.error) {
          exporter.downloadCsv(res)
        }
      })
    },
    sortTable (code) {
      if (!code) { return }

      if (this.sort.active === code) { this.sort.isDesc = !this.sort.isDesc }
      else { this.sort.isDesc = true }

      this.sort.active = code
      this.$store.commit('consumer/setRsvpSortColumn', code)
      this.$store.commit('consumer/setRsvpSortIsDesc', this.sort.isDesc)
      this.$store.commit('consumer/setReservationsCurrentPage', 0)
      this.getTransactions(true)
    },
    call (user) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    serviceLabel (code) { return services.getServiceName(code) },
  },
  watch: {
    conId: function (value) {
      this.init()
    },
    isMobile: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
@import '../../assets/scss/_service-types';
.clearfix{ clear: both; }

.field-label{
  font-size: 13px;
  color: #777;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
}

.filter{
  padding-bottom: 15px;

  .row{
    max-width: inherit;
    width: 100%;
    margin: 0;
  }

  .column:not(:last-child){
    padding-right: 20px;
  }

  .status{
    display: inline-block;
    padding: 20px 15px;
    width: 150px;
  }
}

.search-box{
  display: block;
  position: relative;

  .error-msg{
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    background: #ff6115;
    color: #fff;
    transform-origin: top center;
  }
}
.search{
  box-sizing: border-box;
  display: flex;
  width: 100%;

  .search-input-box{
    width: 100%;
    position: relative;

    input{
      display: inline-block;
      vertical-align: middle;
      margin-top: 0;
      border-radius: 3px 0 0 2px;
      padding-right: 30px;

      &.has-error{ border-color:#f33a27; }
    }
    i{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
      color: #d92626;
      cursor: pointer;
    }
  }
  button{
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    border-radius: 0 3px 2px 0;
    padding: 0 20px;
  }
}

.data-field{
  padding-right: 10px;

  &.no-label{ padding-top: 17px; }
  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;
  }
  .datepicker{ position: relative; }
}

select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;

  &[disabled]{ background-color: #ebebe4; }
}

.date-range{
  position: relative;
  display: inline-block;

  select{
    width: 150px;
    margin-right: 5px;
  }
  .error-msg{
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    padding: 2px 5px;
    font-size: 12px;
    text-align: center;
    background: #ff6115;
    color: #fff;
    transform-origin: top center;
  }
}
.datepicker-box{
  display: inline-block;
  width: 110px;
}

.export{
  text-align: right;
  padding: 15px 10px 0;
  flex: 0 130px;
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{
      padding: 5px 10px;

      &:last-child{ cursor: default; }
      i{ display: none; }
      & i.stripe-icon { display: inline; }
      .fa-sort-up{ vertical-align: -2px; }
      .fa-sort-down{ vertical-align: 2px; }
      &.sortable{
        cursor: pointer;
        color: #333;
        span{
          font-weight: 600;
          text-decoration: underline;
        }
      }
      &.sort i{ display: inline-block; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      &:nth-child(even) { background: #f3f3f3; }
      &:hover { background: #d7dbe4; }
      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        color: #555;

        .status {
          line-height: 1.5;
        }

        &.status, &.bookedThrough{ font-weight: 600; }
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
        a{
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}

.rsvp-type{
  text-transform: uppercase;
  padding: 3px 5px;
  color: #fff;
  border-radius: 4px;

  &.rsvp{ background: #5771d0; }
  &.asap{ background: #d05757; }
  &.package{ background: #26d97a; }
}

.booked-label{
  padding: 3px 5px;
  background: #ccc;
  color: #fff;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 700;

  &.Web{ background: #a26d5d; }
  &.Admin{ background: #2b83f1; }
  &.Android{ background: #78c259; }
  &.iOS{ background: #7fc8de; }
  &.CSR{ background: #bb4a91; }
  &.Provider{ background: #3f3f3f; }
}

.status-label{
  line-height: 1;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 11px!important;
  background: #999;
  display: inline-block;

  &.Purchased, &.Purchase{ background: #4aadf3; }
  &.Completed{ background: #26D97A; }
  &.Promo{ background: #f3904a; }
  &.Edited, &.Refund{ background: #797979; }
  &.No.Show, &.Cancelled, &.Declined{ background: #f54f4f; }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

.service-label{
  line-height: 100%;
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-weight: 700;
  font-size: 12px;
  text-transform: capitalize;

  &.shared{ background: #f38d56; }
  &.opoli{ background: #26D97A; }
  &.black{ background: #777; }
  &.SUV, &.suv{ background: #dc3168; }
  &.shuttle{ background: #6dabc3; }
}

.hideMobile {
  display: none;
}

.datepicker-div {
  display: inline;
}

@media only screen and (max-width: 430px) {
  .datepicker-div {
    display: block;
    margin-top: 5px;
  }

  .column {
    margin-bottom: 5px;
  }

  .export {
    text-align: center;
  }
  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
        .time {
          font-size: 12px;
          color: #777;
          word-spacing: 5px;
        }

        .amount {
          font-weight: 900;
          font-size: 20px;
          a {
            text-decoration: none;
          }
        }
      }

      .tags {
        display: flex;
        justify-content: space-between;

        .rsvp-type {
          font-size: 12px;
          margin-right: 5px;
        }

        .rsvp-stats {
          display: flex;
          align-items: flex-end;
        }

        .status {
          display: flex;
          .refund {
            margin-left: 10px;
          }
        }
      }

      .title {
        display: flex;
        align-items: center;
        .rsvpId {
          font-weight: 900;
          margin-right: 10px;
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/Reservations.vue